module.exports = __webpack_public_path__ + "img/lowest.92b1345d.svg";